module.exports = __webpack_public_path__ + "static/img/19049C_1_2_C_20220322_fit.22db907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19049C_1_2_C_20220322_fit.png
// module id = q75D
// module chunks = 0